import { AvailableErrors } from '@api/izibizi-xp';
import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { Anything } from '@types';
import { AnyAction } from 'redux';
import { ServicesActionTypes, ServicesState } from './services.types';

export const servicesInitialState: ServicesState = {};

export const servicesReducer: (state: ServicesState | undefined, action: AnyAction) => ServicesState = (
	state = servicesInitialState,
	action
): ServicesState => {
	if (action.type === ServicesActionTypes.saveSuccessServiceResponse) {
		return {
			...state,
			...action.payload,
		};
	} else if (action.type === ServicesActionTypes.saveErrorServiceResponse) {
		let error;
		if (Array.isArray(action.payload.errors)) {
			const filterError: Anything = action.payload.errors.filter(
				(error: Anything) => error.message !== undefined || error.code !== undefined
			);

			error =
				filterError.filter((filterErr: Anything) => filterErr.code === AvailableErrors.IziBiziInvalidCAE)
					.length > 0
					? filterError.filter((fError: Anything) => fError.code === AvailableErrors.IziBiziInvalidCAE)[0]
					: filterError.filter((filterErr: Anything) => filterErr.code === AvailableErrors.IziBiziRiskAML)
							.length > 0
					? filterError.filter((fError: Anything) => fError.code === AvailableErrors.IziBiziRiskAML)[0]
					: filterError[0];
		} else if (typeof action.payload.errors === 'string') {
			error = action.payload.errors;
		}

		return {
			...state,
			error: {
				code: error?.code,
				message: error?.message || TranslationHelper.t('general.genericError.title'),
			},
		};
	}

	return state;
};
